import React from 'react';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTrips } from '../data/tripsApi';
import TripCard from './TripCard';

const UpcomingTrips = () => {
  const { t, i18n } = useTranslation();
  const isGr = i18n.language === 'gr';
  const { trips } = useTrips(null, i18n.language);

  // Show only the next 3 upcoming ascents/events (skip courses/classes)
  const upcoming = (trips || [])
    .filter((tr) => (tr.kind === 'expedition' || tr.kind === 'event'))
    .filter((tr) => tr.start_date && new Date(tr.start_date) >= new Date(new Date().toDateString()))
    .slice(0, 3);

  return (
    <section className="py-20 bg-gray-50" data-testid="home-upcoming-trips">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t('trips.title')}</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">{t('trips.subtitle')}</p>
        </div>

        {trips === null ? (
          <div className="flex justify-center py-12">
            <Loader2 className="w-8 h-8 animate-spin text-gray-400" />
          </div>
        ) : upcoming.length === 0 ? (
          <div className="text-center text-gray-500 py-12" data-testid="home-upcoming-empty">
            {isGr ? 'Δεν υπάρχουν προγραμματισμένες εξορμήσεις.' : 'No upcoming ascents scheduled.'}
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {upcoming.map((trip) => (
              <TripCard
                key={trip.id}
                trip={trip}
                linkTo={`/expeditions/${trip.id}`}
                testIdPrefix="home-trip-"
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default UpcomingTrips;
